import GeneralInput from "./styles";

export default GeneralInput;
